import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { canUseDOM } from "exenv";
import React from "react";
import { Icon } from "../../components";
import { Button } from "../Button";
import * as S from "./Drawer.styled";
export var Drawer = function (props) {
    var _a = props.width, width = _a === void 0 ? "medium" : _a, _b = props.isOpen, isOpen = _b === void 0 ? false : _b, _c = props.position, position = _c === void 0 ? "left" : _c, _d = props.lazy, lazy = _d === void 0 ? false : _d, children = props.children, onClose = props.onClose, _e = props.isFullWidth, isFullWidth = _e === void 0 ? false : _e;
    var _f = React.useState(!lazy), renderDrawer = _f[0], setRenderDrawer = _f[1];
    var _g = React.useState(false), isAnimating = _g[0], setIsAnimating = _g[1];
    var _h = React.useState(isOpen), shouldRender = _h[0], setShouldRender = _h[1];
    var body = canUseDOM ? document.querySelector("body") : undefined;
    React.useEffect(function () {
        if (isOpen) {
            setShouldRender(true);
            // Small delay to ensure DOM is ready for animation
            var timer_1 = setTimeout(function () {
                setIsAnimating(true);
                if (lazy) {
                    setRenderDrawer(true);
                }
            }, 10);
            window.addEventListener("keydown", handleKeyDown);
            return function () {
                clearTimeout(timer_1);
                window.removeEventListener("keydown", handleKeyDown);
            };
        }
        setIsAnimating(false);
        window.removeEventListener("keydown", handleKeyDown);
        // Wait for animation to complete before unmounting
        var timer = setTimeout(function () {
            setShouldRender(false);
            if (lazy) {
                setRenderDrawer(false);
            }
        }, 300); // Match the animation duration
        return function () { return clearTimeout(timer); };
    }, [isOpen, lazy]);
    var handleBackdropClick = function (event) {
        handleClose(event);
    };
    var handleBackButtonClick = function (event) {
        handleClose(event);
    };
    var handleKeyDown = function (event) {
        if (event.key === "Escape" && isOpen) {
            handleClose(event);
        }
    };
    var handleClose = function (event) {
        if (onClose) {
            onClose(event);
        }
    };
    if (!body) {
        return null;
    }
    return (_jsx(_Fragment, { children: shouldRender && (_jsxs("div", { children: [_jsx(S.Background, { onClick: handleBackdropClick, isAnimating: isAnimating }), _jsxs(S.Drawer, { width: width, position: position, isAnimating: isAnimating, children: [isFullWidth ? (_jsx(S.DrawerClose, { children: _jsx(Button, { appearance: "plain", onClick: handleBackButtonClick, children: _jsx(Icon, { source: "close" }) }) })) : (_jsx(S.DrawerAside, { children: _jsx(Button, { appearance: "plain", onClick: handleBackButtonClick, children: _jsx(Icon, { size: "large", source: position === "left" ? "chevronLeft" : "chevronRight" }) }) })), renderDrawer && (_jsx(S.DrawerContent, { isFullWidth: isFullWidth, children: children }))] })] })) }));
};
